<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="sanitized" />
</template>

<script setup lang="ts">
import DOMPurify from 'dompurify'

interface Props {
  html: string
}

const props = defineProps<Props>()

const sanitized = computed(() => DOMPurify.sanitize(props.html))
</script>
